import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import RolesTree from '@/views/roles/List.vue';
import RolePermission from '@/views/roles/permissions/List.vue';

export const roleTreeRoute: RouteConfig = {
  path: 'roles',
  name: 'roles',
  component: RolesTree,
  beforeEnter: (to, from, next) => {
    store
      .dispatch(`roles/list`, { count: -1 })
      .then(() => {
        store.commit('breadcrumbs/set', [{ text: 'Role', disabled: true }]);
        next();
      })
      .catch(err => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy uprawnień roli.' }));
  },
  meta: { toolbarTitle: 'Drzewo ról' }
};

export const rolePermissionsRoute: RouteConfig = {
  path: 'roles/:id',
  name: 'rolePermission',
  component: RolePermission,
  beforeEnter: (to, from, next) => {
    Promise.all([
      store.dispatch('roles/get', parseInt(to.params.id)),
      store.dispatch(`roles/rolePermission/list`, parseInt(to.params.id))
    ])
      .then(([role]) => {
        store.commit('breadcrumbs/set', [
          { text: 'Role', to: { name: 'roles' }, exact: true },
          { text: role.name, disabled: true }
        ]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych roli' }));
  },
  meta: { toolbarTitle: 'Drzewo ról' }
};
